import _ from 'lodash'

class Billing {
  constructor(json = {}) {
    _.assign(this, json)

    this.number = '**** **** **** ' + json.lastFour
  }

  static factory($resource, $log, config) {
    return $resource(
      config.billingResourcePath,
      {userId: '@userId'},
      {
        get: {
          method: 'GET',
          transformResponse: function(data, headers) {
            var response
            try {
              response = new Billing(angular.fromJson(data))
            } catch (e) {
              throw e
              response = data
            }

            return response
          }
        }
      }
    )
  }
}

Billing.factory.$inject = ['$resource', '$log', 'config']

export default Billing
